// src/basicRendererPlugin.tsx
import { Fragment } from "react";
import { Fragment as Fragment2, jsx } from "react/jsx-runtime";
function basicRendererPlugin() {
  return () => ({
    key: "plugin-renderer-basic",
    render({ stack }) {
      return /* @__PURE__ */ jsx(Fragment2, { children: stack.render().activities.filter(
        (activity) => activity.transitionState !== "exit-done"
      ).map((activity) => /* @__PURE__ */ jsx(Fragment, { children: activity.render() }, activity.key)) });
    }
  });
}
export {
  basicRendererPlugin
};
//# sourceMappingURL=index.mjs.map
